import { ComponentType, ReactElement, createContext, useContext } from 'react';

import {
  NotFoundContent,
  NotFoundContentProps,
} from '@spotify/confidence-core-react';

const ResourceRecoveryCardContext = createContext<ComponentType>(
  NotFoundContent.DefaultRecovery,
);

export const ResourceRecoveryCardProvider =
  ResourceRecoveryCardContext.Provider;

export const ResourceNotFoundContent = (
  props: NotFoundContentProps,
): ReactElement => {
  const RecoveryCard = useContext(ResourceRecoveryCardContext);
  return (
    <NotFoundContent {...props}>
      <RecoveryCard />
    </NotFoundContent>
  );
};
